import type { VistaBarbearia } from './barbeariaTipos';

export const LS_TOUR_LOJA = 'carioca-tour-loja-v1';

export interface TourStep {
  id: string;
  vista: VistaBarbearia;
  /** Valor de data-tour="..." */
  target: string;
  title: string;
  body: string;
}

/** Tutorial só no app da loja (NW / APK) — não no link do cliente. */
export const TOUR_PASSOS: TourStep[] = [
  {
    id: 'nav',
    vista: 'agendamento',
    target: 'nav-abas',
    title: 'Menus do app',
    body: 'Aqui você troca entre Agendamento, Agenda/Admin, Financeiro e Gastos. Cada aba tem uma função da loja.',
  },
  {
    id: 'agd-cal',
    vista: 'agendamento',
    target: 'agd-calendario',
    title: 'Calendário',
    body: 'Escolha o dia do atendimento. Os horários livres aparecem logo abaixo do calendário.',
  },
  {
    id: 'agd-horas',
    vista: 'agendamento',
    target: 'agd-horarios',
    title: 'Horários livres',
    body: 'Toque no horário disponível. A lista respeita a duração do serviço, bloqueios e o que já foi agendado.',
  },
  {
    id: 'agd-serv',
    vista: 'agendamento',
    target: 'agd-servicos',
    title: 'Serviços e preços',
    body: 'Toque na foto do serviço. O preço e o tempo do corte aparecem aqui para o cliente e para a loja.',
  },
  {
    id: 'agd-brb',
    vista: 'agendamento',
    target: 'agd-barbeiro',
    title: 'Barbeiro',
    body: 'Escolha CARIOCA ou SUB. O horário fica ligado a esse barbeiro na agenda.',
  },
  {
    id: 'agd-ok',
    vista: 'agendamento',
    target: 'agd-confirmar',
    title: 'Confirmar',
    body: 'Depois de nome e WhatsApp, confirme. No app da loja o pedido vai para a Agenda/Admin.',
  },
  {
    id: 'adm-lista',
    vista: 'admin',
    target: 'adm-pedidos',
    title: 'Pedidos agendados',
    body: 'Aqui chegam os agendamentos (do app e do link do cliente). Dá para mudar status, pagamento, notas e apagar um horário para liberar a vaga.',
  },
  {
    id: 'adm-bloq',
    vista: 'admin',
    target: 'adm-bloqueio',
    title: 'Bloquear horários',
    body: 'Trave um intervalo (almoço, folga…) por 1 dia, 1 semana, 1 mês, 1 ano ou nas datas que você escolher.',
  },
  {
    id: 'adm-com',
    vista: 'admin',
    target: 'adm-comissao',
    title: 'Comissão',
    body: 'Ajuste a % de comissão de cada barbeiro. O Financeiro usa isso nos cálculos.',
  },
  {
    id: 'fin',
    vista: 'financeiro',
    target: 'fin-resumo',
    title: 'Financeiro',
    body: 'Veja faturamento, comissões e o que ficou para a casa no dia, na semana ou no mês.',
  },
  {
    id: 'gas',
    vista: 'gastos',
    target: 'gas-painel',
    title: 'Gastos e estoque',
    body: 'Registre despesas fixas/variáveis e controle produtos do estoque da barbearia.',
  },
  {
    id: 'link',
    vista: 'agendamento',
    target: 'btn-link-cliente',
    title: 'Enviar link',
    body: 'Toque em Enviar link para compartilhar o agendamento pelo WhatsApp (ou pelo menu de compartilhar do celular). O cliente só vê a tela de marcar horário.',
  },
];

export function tourJaConcluido(): boolean {
  try {
    return localStorage.getItem(LS_TOUR_LOJA) === 'done';
  } catch {
    return false;
  }
}

export function marcarTourConcluido(): void {
  try {
    localStorage.setItem(LS_TOUR_LOJA, 'done');
  } catch {
    /* ignore */
  }
}

export function resetarTour(): void {
  try {
    localStorage.removeItem(LS_TOUR_LOJA);
  } catch {
    /* ignore */
  }
}
